export default __webpack_public_path__ + "static/media/sickle.ded2dbea.png";